import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { CaretDown } from "@phosphor-icons/react";
import React from "react";
import { ItemListQr } from "./ItemListQr";
import { typeObject } from "../../../../utils/constants";

export const ListPets = ({ list }) => {
  return (
    <Accordion sx={{ marginTop: 2 }}>
      <AccordionSummary
        expandIcon={<CaretDown size={32} />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography fontWeight={700}>Mascotas</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ textAlign: "left" }}>
        {list?.map((item) => (
          <ItemListQr type={typeObject?.pets} item={item} key={item?.id} />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
